import { IAdminAllUsersResponse, IAdminUserDetails } from '../../interfaces/admin-users.interface'

export interface AdminUsersStateModel {
  user: IAdminUserDetails
  allUsers: IAdminAllUsersResponse
}
